
export default function Features() {
  const features = [
    {
      title: '실시간 채용정보',
      subtitle: '매일 업데이트되는 최신 일자리',
      gradient: 'from-[#8B5CF6]/80 to-[#7C3AED]/80',
      image: 'https://public.readdy.ai/ai/img_res/e7478773be44be3999b067a06d72bb21.jpg'
    },
    {
      title: '간편한 지원 프로세스',
      subtitle: '클릭 한 번으로 지원 완료',
      gradient: 'from-[#A855F7]/80 to-[#9333EA]/80',
      image: 'https://readdy.ai/api/search-image?query=simple%20application%20process%20mobile%20interface%20purple%20gradient%20modern%20ui%20design%20one%20click%20apply%20button%20korean%20text%20clean%20professional&width=600&height=450&seq=feature2v2&orientation=landscape'
    },
    {
      title: '급여 관리 시스템',
      subtitle: '투명한 급여 내역 확인',
      gradient: 'from-[#C026D3]/80 to-[#A21CAF]/80',
      image: 'https://readdy.ai/api/search-image?query=salary%20management%20dashboard%20purple%20magenta%20gradient%20financial%20interface%20payment%20tracking%20system%20modern%20clean%20design%20korean%20app%20screen%20professional&width=600&height=450&seq=feature3v2&orientation=landscape'
    }
  ];

  return (
    <section id="features" className="py-16 sm:py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#1A2332] text-center mb-12 md:mb-24">
          온니잡 핵심 기능
        </h2>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-5 md:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`relative rounded-2xl md:rounded-3xl overflow-hidden aspect-[4/3] group cursor-pointer ${index === 2 ? 'sm:col-span-2 md:col-span-1' : ''}`}
            >
              <img
                src={feature.image}
                alt={feature.title}
                className="w-full h-full object-cover"
              />
              <div className={`absolute inset-0 bg-gradient-to-br ${feature.gradient} group-hover:opacity-40 transition-opacity duration-300`}></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-4 sm:p-6 md:p-8">
                <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-1 md:mb-2">
                  {feature.title}
                </h3>
                <p className="text-white/90 text-sm sm:text-base md:text-lg">
                  {feature.subtitle}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
